var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-btn',{staticStyle:{"color":"#FF0080","padding-left":"0"},attrs:{"rounded":"","icon":"mdi-chevron-left","to":_vm.to,"flat":"","color":"blue-grey","label":_vm.$t('back')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }